import { Approver, FormApprovalReviewCommentSchema } from '../types';
import { useMemo } from 'react';

export const useEventFormComments = (reviewers: Approver[], approvers: Approver[]) => {
  return useMemo(() => {
    const reviewer_comments = reviewers.map((reviewer) => {
      return {
        ...reviewer,
        action_status: reviewer.action_status === 'approved' ? 'reviewed' : reviewer.action_status,
      };
    });
    const approversAndReviewers = [...approvers, ...reviewer_comments];
    return approversAndReviewers
      .filter((approver) => approver.action_timestamp && approver.approval_comment)
      .sort((approver1, approver2) => approver2.action_timestamp! - approver1.action_timestamp!)
      .map((approver) =>
        FormApprovalReviewCommentSchema.parse({
          commentTimeStamp: approver.action_timestamp,
          userFullName: approver.full_name,
          status: approver.action_status,
          comment: approver.approval_comment,
        }),
      );
  }, [approvers, reviewers]);
};
